// extracted by css-extract-rspack-plugin
export default {"quote":"content-editor-plugin-quote-Quote-quote-580f90b5","icon":"content-editor-plugin-quote-Quote-icon-f11abcdd"};